import { Link } from 'react-router-dom';
import { usePageMeta } from '@/hooks/usePageMeta';
import './AboutPage.css';

export default function AboutPage() {
  usePageMeta(
    'About',
    'The story behind The Gardeners Calendar — twenty years of helping gardeners grow organically and in step with the seasons.',
  );
  return (
    <div className="about-page">
      <div className="about-header">
        <div className="container-narrow">
          <p className="text-label" style={{ color: 'var(--sage)', marginBottom: 'var(--space-3)' }}>Our Story</p>
          <h1 className="text-display">About The Gardeners Calendar</h1>
          <p className="text-subtitle" style={{ color: 'var(--ink-light)', marginTop: 'var(--space-3)' }}>
            Twenty years of helping gardeners grow with the seasons.
          </p>
        </div>
      </div>

      <div className="container-narrow about-body">
        <article className="paper prose about-article">

          <section className="about-milestone">
            <div className="about-milestone-year">2006</div>
            <h2>Where It All Began</h2>
            <p>
              The Gardeners Calendar was founded in March 2006 with a simple idea: give gardeners a trusted, thoughtful companion for planning their growing year. From the very beginning, the focus was on working with nature rather than against it — following the rhythms of the seasons, the lunar cycle, and the age-old wisdom of organic and biodynamic growing.
            </p>
            <p>
              Over the two decades since, we have guided tens of thousands of gardeners through sowing seasons, harvests, and everything in between.
            </p>
          </section>

          <section>
            <h2>A 20th Birthday Re-launch</h2>
            <p>
              This version of The Gardeners Calendar was re-launched in March 2026 — exactly twenty years after the original site first went live. It is a complete reimagining for the modern web, built from the ground up with the same values that have always defined the project: organic, thoughtful, and rooted in the garden.
            </p>
            <p>
              The new platform brings together everything we have learned from years of listening to gardeners: a comprehensive plant database, biodynamic lunar planting guidance, a personal garden journal, a directory of trusted suppliers and nurseries, and much more.
            </p>
          </section>

          <section>
            <h2>What's Coming Next</h2>
            <p>
              We are working hard on a range of new features for the months ahead. While we are not ready to announce everything just yet, some of the areas we are actively developing include:
            </p>
            <ul>
              <li>Personalised sowing and harvesting calendars based on your location</li>
              <li>Companion planting guides and crop rotation planning</li>
              <li>A community space for gardeners to share tips and seasonal notes</li>
              <li>Expanded biodynamic content and moon planting calendars</li>
              <li>Seed saving records and harvest tracking</li>
            </ul>
            <p>
              The Gardeners Calendar has always been shaped by its community. If you have a feature you would love to see, we want to hear about it.
            </p>
          </section>

          <section>
            <h2>Share Your Ideas</h2>
            <p>
              Have a suggestion for a feature, a piece of content, or anything else you think would make The Gardeners Calendar more useful? We would love to hear from you. Please send your requests and ideas via our <Link to="/contact">contact page</Link> — every message is read, and the best ideas have a way of making it into the calendar.
            </p>
          </section>

          <section>
            <h2>Our Approach</h2>
            <p>
              The Gardeners Calendar is designed for gardeners who care about growing in harmony with the natural world. Our content draws on the principles of organic and biodynamic gardening — practices that have sustained healthy soils and productive gardens for generations.
            </p>
            <p>
              We believe that good gardening is about more than yields. It is about connecting with the seasons, nurturing living soil, and finding joy in the slow, patient work of growing things. That is the spirit we have tried to put into every part of this site.
            </p>
          </section>

        </article>
      </div>
    </div>
  );
}
